
import React from 'react'
import { Container, Tabs, Tab, Button } from 'react-bootstrap'
import { ORDERS_COLLECTION } from '../../firebase'
import { useHistory, useParams } from 'react-router';

const DeleteOrder = () => {

    const { id } = useParams()

    const history = useHistory()

    const handleDelete = () => {
        ORDERS_COLLECTION.doc(id).delete()
            .then(() => {
                alert("Uspješno obrisano 👍")
                history.push('/preview-order')
            })
            .catch((error) => {
                alert(error.message)
            })
    }

    return (
        <>
            <Container>
                <Tabs defaultActiveKey="delete-order" className="mb-3" transition={false}>
                    <Tab eventKey="preview-order" title={<div onClick={() => history.push('/preview-order')}>Pregled narudžbi</div>} />
                    <Tab eventKey="add-order" title={<div onClick={() => history.push('/add-order')}>Dodaj</div>} />
                    <Tab eventKey="edit-order" title='Uredi' disabled />
                    <Tab eventKey="delete-order" title='Obriši'>
                        <Button variant="danger" onClick={handleDelete}>Obriši</Button>
                    </Tab>
                </Tabs>
            </Container>
        </>
    )
}

export default DeleteOrder
